<template>
  <div id="qvvapp">
    <div class="numbercontainer">
      <h1>Coronavirus in Österreich</h1>
      <div class="width-2">
        <BigNumberFaelle
          :austria_timeline="austria_timeline"
          :austria_latest="latest_austria"
          :colors="colors"
          :mobile="mobile"
          :bestaetigte_faelle_summe_aenderung="
            bestaetigte_faelle_summe_aenderung
          "
        >
        </BigNumberFaelle>
      </div>
      <div class="width-2">
        <BigNumberAktivAnteilig
          :bundeslaender_timeline="bundeslaender_timeline"
          :colors="colors"
          :mobile="mobile"
          :active_max_latest="active_max_latest"
          :active_secondmax_latest="active_secondmax_latest"
          :bestaetigte_faelle_summe_aenderung="
            bestaetigte_faelle_summe_aenderung
          "
        >
        </BigNumberAktivAnteilig>
      </div>
      <div class="width-2">
        <BigNumberFaelleZeitraum
          :austria_timeline="austria_timeline"
          :bundeslaender_timeline="bundeslaender_timeline"
          :colors="colors"
          :mobile="mobile"
          :active_max_latest="active_max_latest"
        >
        </BigNumberFaelleZeitraum>
      </div>
      <div class="width-2" v-if="true">
        <AustriaMapPoints
          :highlight_points="bezirke_hotspots_proeinwohner"
          :mobile="mobile"
        >
        </AustriaMapPoints>
      </div>
      <div class="width-2" v-if="false">
        <AustriaMap14dNoCases
          :highlight_points="bezirke_14dnocases"
          :mobile="mobile"
        >
        </AustriaMap14dNoCases>
      </div>
    </div>
    <div class="stand">
      <small
        >Quelle: AGES, BMSGPK<br />Aktualisierung 1x täglich Nachmittags.<br />Letzte:
        {{ last_stand }}</small
      >
    </div>
    <ScrollIcon @click.native="scrolldown"></ScrollIcon>
  </div>
</template>

<script>
import BigNumberAktivAnteilig from "./components/BigNumberAktivAnteilig.vue";
import BigNumberFaelle from "./components/BigNumberFaelle.vue";
import BigNumberFaelleZeitraum from "./components/BigNumberFaelleZeitraum.vue";
import AustriaMapPoints from "./components/AustriaMapPoints.vue";
import AustriaMap14dNoCases from "./components/AustriaMap14dNoCases.vue";
//import VueScriptComponent from 'vue-script-component';
import ScrollIcon from "./components/ScrollIcon.vue";

import data_austria from "./data/oesterreich.csv";
import austria_timeline from "./data/at_timeline.csv";
import bundeslaender_timeline from "./data/bundeslaender_timeline.csv";
import datawrapper_test_embed from "./data/datawrapper_test_embed.txt";

import bezirke_hotspots_proeinwohner from "./data/bezirke_hotspots_proeinwohner.geo.json";
import bezirke_14dnocases from "./data/bezirke_14tagenichts.geo.json";
import bestaetigte_faelle_summe_aenderung from "./data/bundeslaender_faelle_raw.csv";

const moment = require("moment");

moment.locale("de");

const staende_nice = {
  infizierte_stand: "bestätigte Fälle",
  testungen_stand: "Testungen",
  genesene_stand: "Genesene",
  todesfaelle_stand: "Todesfälle",
  krankenhaus_stand: "hospitalisiert",
  intensivstation_stand: "intensiv",
  aktive_stand: "aktive Fälle"
};

export default {
  name: "Dashboard",
  components: {
    AustriaMapPoints,
    AustriaMap14dNoCases,
    BigNumberFaelleZeitraum,
    BigNumberAktivAnteilig,
    BigNumberFaelle,
    ScrollIcon
  },
  data: () => ({
    latest_austria: data_austria[0],
    colors: {
      infizierte: "#FC902A",
      infizierte_tag: "#FC902A",
      infizierte_highlight: "#FF6600",
      todesfaelle: "#D83F15",
      genesene: "#6CC667",
      testungen: "#A8DDD0",
      dopplung: "rgb(247, 188, 99)",
      hospitalisiert: "#6767ee",
      intensivstation: "#7b98d0",
      schaetzung_aktive: "rgb(255, 222, 91)",
      davon_max_aktive: "#888",
      davon_secondmax_aktive: "#3b3a39"
    },
    dw_embed_test: datawrapper_test_embed,
    austria_timeline: austria_timeline,
    mobile: null,
    bundeslaender_timeline: bundeslaender_timeline,
    bezirke_hotspots_proeinwohner: bezirke_hotspots_proeinwohner,
    bezirke_14dnocases,
    staende_nice,
    show_standdetail: false,
    bestaetigte_faelle_summe_aenderung
  }),
  mounted() {
    this.update_mobile();
    window.addEventListener("resize", this.update_mobile);
  },
  methods: {
    update_mobile() {
      this.mobile =
        window.innerWidth >= 700
          ? null
          : window.innerWidth < 350
          ? "supermobil"
          : "mobil";
    },
    scrolldown() {
      window.scrollTo({
        top: this.$el.clientHeight,
        left: 0,
        behavior: "smooth"
      });
    }
  },
  computed: {
    staende() {
      return Object.keys(this.latest_austria).filter(
        d => d.indexOf("scrape_time") >= 0
      );
    },
    last_stand() {
      return this.latest_austria[Object.values(this.staende)[0]];
    },
    stand_by_day_time() {
      var r = {};
      this.staende.forEach(k => {
        var v = this.latest_austria[k];
        var day = v.slice(0, 6);
        var time = v.slice(10, v.length);
        if (!r[day]) {
          r[day] = {};
        }
        if (!r[day][time]) {
          r[day][time] = [];
        }
        r[day][time].push(k);
      });
      return r;
    },
    stand_str() {
      return Object.keys(this.stand_by_day_time)
        .map(
          day =>
            `${day} ${Object.keys(this.stand_by_day_time[day])
              .map(
                time =>
                  `${time} ${this.stand_by_day_time[day][time]
                    .map(standkey => `${this.staende_nice[standkey]}`)
                    .join(", ")}`
              )
              .join("")}`
        )
        .join("; ");
    },
    active_austria_latest() {
      return this.bundeslaender_timeline
        .filter(d => d.land == "Österreich")
        .reverse()[0];
    },
    active_max_latest() {
      return this.active_last_day_data_sorted[0];
    },
    active_secondmax_latest() {
      return this.active_last_day_data_sorted[1];
    },
    active_last_day() {
      return this.active_austria_latest.datum;
    },
    active_last_day_data_sorted() {
      var ldd = this.bundeslaender_timeline.filter(
        d => d.datum == this.active_last_day
      );
      ldd.sort(
        (a, b) =>
          b["bestätigte_Fälle_zweiwochen_diff"] -
          a["bestätigte_Fälle_zweiwochen_diff"]
      );
      return ldd.filter(d => d.land != "Österreich");
    }
  }
};
</script>

<style scoped>
#qvvapp {
  background: #3b3a39;
  margin: 0;
  display: flex;
  align-content: center;
  flex-direction: column;
  color: #f5f5f5;
  justify-content: center;
  box-sizing: border-box;
  font-family: Roboto, sans-serif;
  padding: 0.5em;
  padding-bottom: 50px;
  position: relative;
  /* max-width: 1110px; */
  margin-left: auto;
  margin-right: auto;
}

h1 {
  color: #f5f5f5;
  text-align: center;
  margin: 0;
  margin-top: 0.5em;
  border-bottom: 4px solid white;
}

.width-1 {
  box-sizing: border-box;
  width: 50%;
  min-height: 125px;
  display: flex;
  flex-direction: column;
}
.width-2 {
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
}

@media (min-width: 450px) {
  .width-1 {
    width: 33%;
  }

  .width-2 {
    width: 66%;
  }
}

@media (min-width: 700px) {
  #qvvapp {
    padding: 3vh;
  }

  h1 {
    font-size: 34px;
    margin-right: 0;
    width: 100%;
    text-align: left;
    padding-left: 6px;
    border: none;
  }
  h1::after {
    display: block;
    width: 250px;
    height: 5px;
    background: white;
    content: " ";
  }

  .width-1 {
    width: 25%;
  }

  .width-2 {
    width: 50%;
  }
}

@media (min-width: 900px) {
  h1 {
    font-size: 40px;
    padding-left: 33.6px;
  }
}

.numbercontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
  align-content: center;
  width: 100%;
}

.bignumber {
  /*background: rgb(57,56,55);*/
  box-sizing: content-box;
  margin: 12px 0px;
  flex-grow: 1;
}

.mapcontainer {
  box-sizing: content-box;
  flex-grow: 1;
}

@media (min-width: 700px) {
  #qvvapp {
    padding: 1em;
  }
}

@media (min-width: 900px) {
}

.stand,
.standdetail {
  text-align: right;
  color: lightgrey;
  line-height: 8px;
}

.stand .info {
  cursor: pointer;
  display: inline-block;
  margin-top: 2px;
}

.stand .info svg path {
  stroke: #f5f5f5;
}

.standdetail {
  position: absolute;
  background: rgba(0, 0, 0, 0.9);
  right: 0;
  font-size: 10px;
  padding: 10px;
  line-height: 1.2em;
  z-index: 10;
}

small {
  font-size: 10px;
}
</style>
